import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'src/hooks/routerCompat';
import userManager from '../../services/userManager';
import config from '../../config';

type CallbackPageProps = RouteComponentProps<{}>;

function CallbackPage(props: CallbackPageProps) {
  const [error, setError] = useState<string>('');

  useEffect(() => {
    // check they didnt hit this page directly.
    const url = window.location.href;
    const hasOidcParams = url.includes('code=') || url.includes('id_token=') || url.includes('error=');
    if (!hasOidcParams) {
      console.warn('No OIDC params found — redirecting to login');
      window.location.replace(config.PORTAL_BASE_URL);
      return;
    }

    userManager
      .signinRedirectCallback()
      .then((user) => redirectSuccess((user?.state as { returnPath?: string } | undefined)?.returnPath))
      .catch((error: Error) => {
        console.error('signinRedirectCallback failed:', error);

        // happens if someone bookmarks a page with an expired token in the url 
        if (error.message.includes('No matching state')) {
          window.location.replace(config.PORTAL_BASE_URL);
          return; 
        }
        
        setError(error.message); 
      });
  }, []); 

  function redirectSuccess(returnPath?: string) {
    props.history.replace(returnPath || '/');
  }

  if (error) {
    return (
      <div className="container">
        <div className="alert alert-danger">
          <div className="form-group">
            <strong>Error signing in:</strong> {error}
          </div>
          <div style={{ width: '100%' }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                window.location.replace(config.PORTAL_BASE_URL);
              }}
            >
              Return to login page
            </button>
          </div>
        </div>
      </div>
    );
  }

  return <div className="loader">Loading...</div>;
}

export default withRouter(CallbackPage);
